import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { KEY_LANGUAGE_STORAGE } from 'src/app/core/utils';

@Pipe({
    name: 'localizedDate',
    standalone: true
})
export class LocalizedDatePipe implements PipeTransform {
  transform(
    value: string | number | undefined,
    pattern: string = 'fullDate'
  ): string | null {
    const datePipe: DatePipe = new DatePipe(
      localStorage.getItem(KEY_LANGUAGE_STORAGE) || 'en'
    );
    return value ? datePipe.transform(value, pattern) : "";
  }
}
